import { formatNumber } from '../utils/localization';

class Bid {
  minBidThreshold;

  highBidThreshold;

  bidIncrement;

  maxBid;

  proxyAmount;

  topBidder;

  minBidAmount;

  minProxyAmount;

  hasActiveProxy;

  isTopBidder;

  constructor(
    minBidThreshold,
    highBidThreshold,
    bidIncrement,
    maxBid,
    proxyAmount,
    topBidder,
    hasActiveProxy,
    isTopBidder
  ) {
    this.minBidThreshold = minBidThreshold;
    this.highBidThreshold = highBidThreshold;
    this.bidIncrement = bidIncrement;
    this.proxyAmount = proxyAmount;
    this.maxBid = maxBid;
    this.topBidder = topBidder;
    this.hasActiveProxy = hasActiveProxy;
    this.isTopBidder = isTopBidder;
    this.minBidAmount = this.getMinBid();
    this.minProxyAmount = this.getMinProxyAmount();
  }

  getMinBid() {
    return this.getNextMinBid();
  }

  getMinProxyAmount() {
    if (!this.hasActiveProxy && !this.isTopBidder) {
      return this.getNextMinProxyBid();
    }
    if (this.hasActiveProxy && this.isTopBidder) {
      return this.maxBid;
    }
    return this.getNextMinBid();
  }

  getNextMinBid() {
    const currentBid = this.maxBid;
    const { bidIncrement } = this;

    if (this.minBidThreshold && this.maxBid < this.minBidThreshold) {
      return this.minBidThreshold;
    }

    const bidAmount = currentBid + bidIncrement;
    // Make sure the new bidAmount is still a multiple of the bidIncrement
    const remainder = bidAmount % bidIncrement;
    return bidAmount - remainder;
  }

  getNextMinProxyBid() {
    return this.getNextMinBid() + this.bidIncrement;
  }

  static formatBidAmount(bidAmount) {
    return formatNumber(
      {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        currencyDisplay: 'narrowSymbol'
      },
      bidAmount
    );
  }

  static isValidBidAmount(bidAmount, bidIncrement): boolean {
    return bidAmount % bidIncrement === 0;
  }
}

export default Bid;
